import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";
import { toast, Toaster } from "sonner";
import * as Sentry from "@sentry/react";
import { useEffect, useState } from "react";
import { set } from "zod";

interface ProfileSettingsProps {
  children: React.ReactNode;
}

export default function ProfileSettings({children}: ProfileSettingsProps) {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState<boolean>(false);


    const handleLogOut = () => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('username');
        toast.success("Logged out successfully");
        setTimeout(() => {
            window.location.reload();
        }, 1700);
        
    }
    
    return(
        <>
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger>{children}</DialogTrigger>
            <DialogContent className="dark text-white">
                <DialogHeader>
                <DialogTitle>Settings</DialogTitle>
                <DialogDescription>
                    Modify and manage your profile preferences and settings.
                </DialogDescription>
                </DialogHeader>
               
                <section className="flex flex-col gap-2 justify-center">
                    <h3 className="text-sm text-neutral-400 text-center">Account</h3>
                    <article className="flex flex-row gap-2 justify-center">
                        <Button onClick={() => handleLogOut()} className="bg-transparent text-white border-2 hover:bg-neutral-900 hover:cursor-pointer" >
                           Logout
                        </Button>
                        
                        
                    </article>
                    
                </section>

                <section className="flex flex-col gap-2 justify-center">
                    <h3 className="text-sm text-neutral-400 text-center">Data</h3>
                    <article className="flex flex-row gap-2 justify-center">
                        <Button className="bg-transparent border-neutral-500 text-neutral-500 border-2 hover:bg-neutral-900 hover:cursor-not-allowed" >
                           Request your data
                        </Button>
                        <Button className="bg-transparent border-neutral-500 text-neutral-500 border-2  hover:bg-neutral-900 hover:cursor-not-allowed" >
                           Link Spotify
                        </Button>
                        
                    </article>
                    
                </section>

                <section className="flex flex-col gap-2 justify-center">
                    <h3 className="text-center text-sm text-neutral-400">Scary zone</h3>
                    <article className="flex flex-row justify-center">
                        <Button className="bg-transparent  border-2 border-neutral-500 text-neutral-500 hover:bg-red-900 hover:cursor-not-allowed" >
                            Delete account
                        </Button>
                    </article>
                    
                </section>

                <section className="flex flex-col gap-2 justify-center">
                    <h3 className="text-center text-sm text-neutral-400">Feedback</h3>
                    <article className="flex flex-row justify-center">
                        <CreateFeedbackFromButton isOpen={isOpen} setIsOpen={setIsOpen}/>
                    </article>
                    
                </section>
                

            </DialogContent>
        </Dialog>
        </>
    )
}

interface Feedback { 
    isOpen: boolean;
    setIsOpen: (isForm: boolean) => void;
}

function CreateFeedbackFromButton({isOpen, setIsOpen}:Feedback) {
  const [feedback, setFeedback] = useState();
 
  useEffect(() => {
    setFeedback(Sentry.getFeedback());
  }, []);

  if (!feedback) {
    console.log("No feedback instance");
    return null;
  }

  return (
    <Button
    className="bg-transparent text-white border-2 hover:bg-neutral-900 hover:cursor-pointer"
      type="button"
      onClick={async () => {
        setIsOpen(false);
        const form = await feedback.createForm();
        form.appendToDom();
        form.open();
      }}
    >
      Give Feedback
    </Button>
  );
}